/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LogUtils } from "abweb/utils/log/LogUtils";
const LOG = LogUtils.getLogger(__filename);

// const NODE_ENV: "production" | "development" = process.env.NODE_ENV;
const NODE_ENV = process.env.NODE_ENV;

// CAT-1846: Want some indication at startup whether in production or development mode, which
// indicates the mode of react, react-dom, mobx, ... libraries that are being used (production or development)
LOG.info(`Application is in NODE_ENV='${NODE_ENV}' mode.`);

// Injected by webpack definePlugin when devserver is running
let appServerDeployUrl = __DEVSERVER__.APPSERVER_DEPLOY_URL;
if (appServerDeployUrl) {
  // MH-20000 - ensure if external users running against devserver on hostname=foo, then assume appserver is also hostname=foo.
  appServerDeployUrl = appServerDeployUrl.replace("//localhost", "//" + window.location.hostname);
}
export class BundleStateService {
  constructor() {}
  static get isProduction() {
    return NODE_ENV === "production";
  }

  /**
   * @returns appserver url (including context root, such as "http://localhost:1234/myApp")
   * when running against the webpack devserver, and undefined otherwise
   */
  static get appServerDeployUrl() {
    return appServerDeployUrl;
  }
}
//# sourceMappingURL=BundleStateService.js.map
